import { registerLocaleData } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { DfuUpdate } from '@awesome-cordova-plugins/dfu-update/ngx';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
// import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { Ndef, NFC } from '@awesome-cordova-plugins/nfc/ngx';
import { BleClient, numbersToDataView, numberToUUID } from '@capacitor-community/bluetooth-le';
import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { QuicklinkModule } from 'ngx-quicklink';

import { ApiModule } from '../app/shared/typescript-angular-client/api.module';
import { environment } from '../environments/environment';

import { SyncHelpModalPage } from './access/create/type-choice/stepper/sync-help-modal/sync-help-modal.page';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfirmModalPage } from './device/detail/access/delete/confirm-modal/confirm-modal.page';
import { ConfirmResetModalPage } from './device/detail/confirm-reset-modal/confirm-reset-modal.page';
import { OpenComponent } from './device/open/open.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LocalisationModalComponent } from './localisation-modal/localisation-modal.component';
import { SharedModule } from './shared/modules/shared.module';
import { SyncComponent } from './site/sync/sync.component';
import { provideNativeDateAdapter } from '@angular/material/core';


registerLocaleData(localeFr);
// Ionic requires an exported function for factories
// export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
//     return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

@NgModule({
    declarations: [
        AppComponent,
        OpenComponent,
        SyncComponent,
        LocalisationModalComponent,
        ConfirmModalPage,
        ConfirmResetModalPage,
        SyncHelpModalPage
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        ApiModule,
        SharedModule,
        QuicklinkModule,
        IonicStorageModule.forRoot(),
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix:".json"}),
        }),
        IonicModule.forRoot(),
        AppRoutingModule,
        BrowserAnimationsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })],
    providers: [
        Diagnostic,
        Platform,
        BLE,
        Geolocation,
        NFC,
        Ndef,
        File,
        HTTP,
        DfuUpdate,
        // FilePath,
        provideNativeDateAdapter(),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule { }
